import React, { createContext, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import ReportForm from '../ReportForm/ReportForm';
import SMLModal from '../../../../shared/components/SMLModal';
import SongInfoReportAll from './SongInfoReportAll';
import SongInfoReportEdit from './SongInfoReportEdit';
import SongInfoReportSingle from './SongInfoReportSingle';
import Buttons from './Buttons';
import { updateReportItem } from '../ReportForm/UpdateReportItem';
import { post } from '../../../../shared/components/ApiRequest';

export const ReportModalContext = createContext();

const ReportModal = (props) => {
  const [title, setTitle] = useState('');
  const [composers, setComposers] = useState('');
  const [artist, setArtist] = useState('');
  const [selectedTitles, setSelectedTitles] = useState([]);
  const [selectedTitleIds, setSelectedTitleIds] = useState([]);
  const [singleTitleId, setSingleTitleId] = useState([]);
  const [type, setType] = useState('report-single');
  const [master, setMaster] = useState(false);
  const [btnData, setBtnData] = useState({});
  const [dataToFill, setDataToFill] = useState({});
  const [formData, setFormData] = useState({});
  const [showForm, setShowForm] = useState(true);

  useEffect(() => {
    if (btnData === {}) return;

    setTitle(btnData.title);
    setComposers(btnData.composers);
    setArtist(btnData.artist);
    setType(btnData.type);
    setMaster(!!btnData.master);
    setDataToFillForm(btnData);

    if (btnData.hasOwnProperty('idSong')) {
      setSingleTitleId(btnData.idSong);
    }
  }, [btnData]);

  useEffect(() => {
    setShowForm(type !== 'report-all' || selectedTitles.length > 0);
  }, [selectedTitles, type]);

  useEffect(() => {
    $(document).off('click.report-modal', '[data-target="#reportModal"]')
      .on('click.report-modal', '[data-target="#reportModal"]', function () {
        setBtnData($(this).data());
      });
  }, []);

  const setDataToFillForm = (data) => {
    const prefilledData = {};
    const fields = ['id', 'postedVideos', 'lyricUses', 'masterUses', 'masterSource', 'idRegistration', 'idRegistrationSong', 'idReprint'];

    fields.forEach(field => {
      if (data.hasOwnProperty(field)) {
        prefilledData[field] = data[field];
      }
    });

    if (!data.master) {
      prefilledData.masterUses = null;
      prefilledData.masterSource = null;
    }

    setDataToFill(prefilledData);
  };

  const handleSubmitEdit = async (e) => {
    const data = await post('/my-account/report/save-report', {...formData, titles: getTitlesIds()}, $(e.target));

    updateReportItem(data.idRegistrationSong, data);

    hideModal();
  }

  const handleSubmitContinue = async (e) => {
    await post('/my-account/report/report-titles', {...formData, titles: getTitlesIds()}, $(e.target));

    hideModal();
  }

  const handleSubmitView = async (e) => {
    const data = await post('/my-account/report/report-titles', {...formData, titles: getTitlesIds()}, $(e.target));

    window.location = data.link;

    hideModal();
  }

  const getTitlesIds = () => {
    return type === 'report-all' ? selectedTitleIds : [singleTitleId];
  };

  const handleModalShown = () => {
    const titles = [];
    const ids = [];
    $('input.report-checkbox').each(function () {
      if ($(this).is(':checked')) {
        titles.push($(this).data('title'));
        ids.push($(this).data('idSong'));
      }
    });

    setSelectedTitles(titles);
    setSelectedTitleIds(ids);
  };

  const hideModal = () => {
    $('#reportModal').modal('hide');
  }

  return (
    <SMLModal onShown={handleModalShown} id={'reportModal'} size={'lg'}>
      {type === 'report-all' &&
        <SongInfoReportAll selectedTitles={selectedTitles} />
      }

      {type === 'report-single' &&
        <SongInfoReportSingle title={title} composers={composers} artist={artist} />
      }

      {type === 'report-edit' &&
        <SongInfoReportEdit title={title} composers={composers} artist={artist} />
      }

      {showForm &&
        <>
          <ReportForm
            postedVideosChoices={props.postedVideosChoices}
            lyricUsesChoices={props.lyricUsesChoices}
            masterUsesChoices={props.masterUsesChoices}
            masterSourceChoices={props.masterSourceChoices}
            master={master || type === 'report-all'}
            dataToFill={dataToFill}
            onChange={setFormData}
          >
          </ReportForm>

          <Buttons
            type={type}
            onSubmitContinue={handleSubmitContinue}
            onSubmitView={handleSubmitView}
            onSubmitEdit={handleSubmitEdit}
          />
        </>
      }
    </SMLModal>
  );
};

export default ReportModal;

// Bind react component to all occurences of html tag with id ReportModal
$('#ReportModal').each(function () {
  createRoot(this).render(
    React.createElement(ReportModal, { ...($(this).data()) })
  );
});